import { jobStatusConfig } from '@/constants/job-constants';
import { type Job as JobType } from '@/pages/AISearch/types/search.types';
import { KText } from '@/ui-library/components';
import { Box, Center, Flex } from '@chakra-ui/react';
// import { Briefcase01 } from '@kula-ai/icons-core';
import { LayersThree02 } from '@kula-ai/icons-core';
// import { MarkerPin01 } from '@kula-ai/icons-core';
// import { IconText } from '../IconText';
// import { JobItem as JobItemType } from '../types';
// import { SearchItemWrapper } from './SearchItemWrapper';
import { Link } from 'react-router-dom';
import { useEffect, useRef } from 'react';
// import { HighlightedTooltipText } from '../text';

interface JobItemProps {
  item: JobType;
  isSelected?: boolean;
  onSearchClose?: () => void;
}

export const JobItem = ({ item, isSelected, onSearchClose }: JobItemProps) => {
  const itemRef = useRef<HTMLAnchorElement>(null);
  const { color = 'pastel-2-light', label = 'Open' } =
    jobStatusConfig?.[item.status ?? 'published'] || {};
  const departments = item.departments?.[0] || '-';
  const offices = item.offices?.[0] || '-';

  useEffect(() => {
    if (isSelected && itemRef.current) {
      itemRef.current.scrollIntoView({ block: 'nearest' });
    }
  }, [isSelected]);

  return (
    <Link
      to={`/jobs/${item.id}`}
      style={{ textDecoration: 'none' }}
      ref={itemRef}
      onClick={() => onSearchClose?.()}
    >
      <Flex
        alignItems="center"
        gap="12px"
        p="12px"
        borderRadius="6px"
        cursor="pointer"
        _hover={{
          backgroundColor: 'secondary-50',
        }}
        backgroundColor={isSelected ? 'secondary-50' : undefined}
      >
        <Center
          width="36px"
          height="36px"
          borderRadius="xs"
          bg="pastel-7-light"
        >
          <LayersThree02
            size="1rem"
            color="var(--kula-colors-pastel-7-dark)"
            className="kula-icon"
          />
        </Center>
        <Flex flexDirection="column">
          <Flex gap="6px" overflow="hidden">
            <KText size="sm-medium" color="secondary-900" fontWeight="550">
              {item.name}
            </KText>
            <KText
              variant="paragraph"
              color="secondary-700"
              p="1px 8px"
              borderRadius="xs"
              border="1px solid"
              borderColor="secondary-100"
              textTransform="capitalize"
              display="flex"
              alignItems="center"
              gap="4px"
              lineHeight="20px"
              whiteSpace="nowrap"
            >
              <Box bg={color} borderRadius="full" w="8px" h="8px" />
              {label}
            </KText>
          </Flex>
          <Flex>
            <KText
              size="sm-regular"
              color="secondary-700"
              mr="10px"
              display="flex"
              alignItems="center"
              gap="6px"
            >
              {departments}{' '}
              <Flex
                bg="secondary-700"
                width="3px"
                height="3px"
                borderRadius="full"
              ></Flex>
              {offices}
            </KText>
          </Flex>
        </Flex>
      </Flex>
    </Link>
  );
};
